// bao migrate skip
import TabPage from "./../../factories/tab-page";
import "./../../factories/tab-controller";
import "./../../bindings/bao-tabs";
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import SubscriptionViewModel from "./../../factories/subscription-view-model";
import baoRouter from "./../../services/bao-router";
import BaoDialog from "./../../factories/bao-dialog";
import BaoMenu from "./../../services/bao-menu";
import finitoService from "./../../services/finito-service";
import TabController from "./../../factories/tab-controller";
import baoShouter from "./../../services/bao-shouter";
import MessageBus, { IMessageBusEventHandler } from "./../../services/message-bus";

class ShiftReportSummaryReport extends SubscriptionViewModel {
    SelectedSummaryFilter = ko.observable<{
        SummaryReportId: KnockoutObservable<string>;
        Name: KnockoutObservable<string>;
        FilterInterval: KnockoutObservable<number>;
        FilterIntervalKey: KnockoutObservable<string>;
        IsIndividually: KnockoutObservable<boolean>;
    }>();
    Color: string = "text-primary";
    Icon: string = "fal fa-layer-group";
    Sort: number = 120;
    Selection = ko.observableArray();
    IsRead = ko.observable<boolean>(false);
    ReadByText = ko.observable<string>("");
    IsCanMarkAsRead = ko.observable<boolean>(false);
    Infos: KnockoutObservableArray<any> = ko.observableArray();
    TotalRows = ko.observable(0);
    PageIndex = ko.observable(0);
    PageSize = ko.observable(20);
    Sorting = ko.observableArray();
    CustomFilter = ko.observable({});
    Columns: KnockoutObservableArray<{}> = ko.observableArray();
    TagColumns: KnockoutObservableArray<{}> = ko.observableArray();
    ShiftReport: {
        ShiftbookId: KnockoutObservable<string>;
        ShiftStartTimeHtml: KnockoutObservable<string>;
        ShiftEndTimeHtml: KnockoutObservable<string>;
        TabViewModel: Factories.TabController;
        ReportId: KnockoutObservable<string>;
        IsShiftClosure: KnockoutObservable<boolean>;
        IsOriginal: KnockoutObservable<boolean>;
        CurrentRevision: KnockoutObservable<boolean>;
    } = null;
    StartDate = ko.observable("");
    RecordChangedMessage: KnockoutObservable<string>;
    TabPageIsActive: KnockoutObservable<boolean>;
    ReportHasChanges: KnockoutObservable<boolean>;
    HideTransferred: KnockoutObservable<boolean> = ko.observable(false);

    InfoSavedHandler: IMessageBusEventHandler = {
        name: 'notifyInfoSaved',
        handler: (result: { ids: Array<string> }) => this.checkAndNotifyIfRecordChanged(result.ids)
    };
    InfoDeletedHandler: IMessageBusEventHandler = {
        name: 'notifyInfoDeleted',
        handler: (result: { ids: Array<string> }) => this.checkAndNotifyIfRecordChanged(result.ids)
    };
    constructor(tabPage: TabPage, parent: any) {
        super(tabPage);
        this.ShiftReport = parent;
        this.ReportHasChanges = ko.observable(false);
        this.TabPageIsActive = this.TabPage.IsActiveTab
    }
    init() {
        this.TabPage.IsLoading(true);
        return this.LoadSummaryReport()
            .then(() => this.CalculateStartDate());
    }
    CalculateStartDate(): JQueryPromise<any> {
        if (this.SelectedSummaryFilter().IsIndividually) {
            this.StartDate(this.ShiftReport.ShiftStartTimeHtml());
            return this.Refresh(true);
        }
        else {
            return Bao.post("SummaryReportV2/CalculateFilterIntervalStartDate", JSON.stringify({
                value: this.ShiftReport.ShiftStartTimeHtml(),
                filterIntervalKey: this.SelectedSummaryFilter().FilterIntervalKey,
                filterInterval: this.SelectedSummaryFilter().FilterInterval
            })).then(result => {
                this.StartDate(result.Result);
                return this.Refresh(true);
            });
        }
    }
    LoadSummaryReport(): JQueryPromise<any> {
        return Bao.post("ShiftReportTabSummaryReport/GetSummaryReportsbyShiftbookTabId", JSON.stringify({
            shiftbookId: this.ShiftReport.ShiftbookId(),
            shiftbookTabId: this.TabPage.ObjectId()
        })).
            then((serverResult) => {
                this.PageIndex(0);
                this.SelectedSummaryFilter(serverResult.SummaryReport);
                this.HideTransferred(JSON.parse(serverResult.HideTransferred));
        });
    }
    loaded() {
        this.dispose();
        this.Sorting([{ Column: "InfoNr", Direction: "Descending" }]);
        this.Sorting.subscribe(() => { this.Refresh(); });
        this.CustomFilter.subscribe(() => { this.ResetViewAndRefresh(); });
        this.PageIndex.subscribe(() => { this.Refresh(); });
        this.PageSize.subscribe(() => { this.ResetViewAndRefresh(); });

        this.registerReportContentChangedHandler();
        this.RecordChangedMessage = Bao.Session.GetMessage('msgSummaryReportContentChanged');

        this.ReportHasChanges.subscribe(function (hasChanges) {
            if (hasChanges && this.TabPageIsActive()) {
                baoShouter.show(this.RecordChangedMessage(), 'warning', -1);
                this.ReportHasChanges(false);
            }
        }.bind(this));

        this.TabPageIsActive.subscribe(function (isActive) {
            if (isActive && this.ReportHasChanges()) {
                baoShouter.show(this.RecordChangedMessage(), 'warning', -1);
                this.ReportHasChanges(false);
            }
        }.bind(this));

        this.ShiftReport.IsOriginal.subscribe(function (isOriginal) {
            if (isOriginal) {
                this.Refresh();
            }
        }.bind(this));

        this.ShiftReport.CurrentRevision.subscribe(function (currentRevision) {
            if (currentRevision) {
                this.Refresh();
            }
        }.bind(this));

        this.ShiftReport.IsShiftClosure.subscribe(function (isShiftClosure) {
            if (isShiftClosure) {
                this.Refresh();
            }
        }.bind(this));

        this.HideTransferred.subscribe((hideTransferred) => {
            Bao.post("SummaryReportV2/SetHideTransferred", JSON.stringify({
                hideTransferred
            })).then(() => { this.Refresh(); });
        });

        this.TabPage.IsLoading(false);
    }
    Refresh(refreshColumnList: boolean = false) {
        this.TabPage.IsLoading(true);
        return $.when(refreshColumnList ? this.SetColumns() : null, this.getSummaryReportData()).always(() => this.TabPage.IsLoading(false));
    }
    SetColumns(): JQueryPromise<any> {
        return Bao.post("SummaryReportV2/GetAllColumns", JSON.stringify({
            summaryReportId: this.SelectedSummaryFilter().SummaryReportId
        })).then(result => {
            this.Columns(result.Columns);
            this.TagColumns(result.TagColumns);
        });
    }
    ResetViewAndRefresh(refreshColumnList: boolean = false) {
        if (this.PageIndex() === 0) {
            this.TabPage.IsLoading(true);
            this.Refresh(refreshColumnList);
            return;
        }
        this.PageIndex(0);
    }
    private toHashObject(customFilter: any) {
        var returnValue = [];
        for (var f in customFilter) {
            returnValue.push({ Key: f, Value: ko.unwrap(customFilter[f]) });
        }
        return returnValue;
    }
    private getSummaryReportData() {
        let extendedCustomFilter = this.toHashObject(this.CustomFilter());
        extendedCustomFilter.push({ Key: "IsShiftClosure", Value: JSON.stringify(this.ShiftReport.IsShiftClosure()) });
        extendedCustomFilter.push({ Key: "IsOriginal", Value: JSON.stringify(this.ShiftReport.IsOriginal()) });
        if (this.HideTransferred()) {
            extendedCustomFilter.push({ Key: "HideTransferred", Value: ko.unwrap(this.HideTransferred) });
        }

        return Bao.post("SummaryReport/GetAll", JSON.stringify({
            summaryReportFilterId: this.SelectedSummaryFilter().SummaryReportId,
            pageIndex: this.PageIndex(),
            pageSize: this.PageSize(),
            sorting: this.Sorting(),
            customFilter: extendedCustomFilter,
            startTime: this.StartDate(),
            endTime: this.ShiftReport.ShiftEndTimeHtml()
        })).then(result => {
            this.Infos(result.Infos);
            this.TotalRows(result.TotalRows);
            this.ReadByText(result.ReadByText);
            this.IsRead(result.IsRead);
            this.IsCanMarkAsRead(result.IsCanMarkAsRead);
        });
    }

    protected checkInfoRelevance(InfoIds: string[]) {
        var customFilterWithInfoId = this.toHashObject(this.CustomFilter());
        customFilterWithInfoId.push({ Key: "InfoIds", Value: JSON.stringify(InfoIds) });
        return Bao.post("SummaryReport/CheckInfoRelevance", JSON.stringify({
            summaryReportFilterId: this.SelectedSummaryFilter().SummaryReportId,
            pageIndex: this.PageIndex(),
            pageSize: this.PageSize(),
            sorting: this.Sorting(),
            customFilter: customFilterWithInfoId,
            startTime: this.StartDate(),
            endTime: this.ShiftReport.ShiftEndTimeHtml()
        })).then(result => {
            return result.Result === true;
        });
    }

    getTagValue = function (tagId, info) {
        if (info.UniversalFieldValues) {
            for (var n = 0; n < info.UniversalFieldValues.length; n++) {
                if (info.UniversalFieldValues[n].InfoId === info.InfoId && info.UniversalFieldValues[n].TagId === tagId) {
                    return info.UniversalFieldValues[n].TagValueHtml;
                }
            }
        }
        return "";
    };
    getTagType = function (tagId, info) {
        if (info.UniversalFieldValues) {
            for (var n = 0; n < info.UniversalFieldValues.length; n++) {
                if (info.UniversalFieldValues[n].InfoId === info.InfoId && info.UniversalFieldValues[n].TagId === tagId) {
                    return info.UniversalFieldValues[n].UniversalFieldTypeId;
                }
            }
        }
        return "";
    };
    link = (infoModel, col) => {
        if (infoModel) {
            this.openInfo(infoModel.InfoId);
        }
    };
    openInfo = (infoId) => {
        var index = null;
        if (infoId == null) {
            if (this.Selection().length > 0) {
                let tempItem: any = this.Selection()[0];
                infoId = tempItem.InfoId;
            }
        }
        var i = 0;
        ko.utils.arrayForEach(this.Infos(), function (item) {
            let tempItem: any = item;
            if (tempItem.InfoId == infoId) {
                index = i;
            }
            i++;
        });
        if (infoId == null) {
            return;
        }
        if (index != null) {
            index = index + (this.PageIndex() * this.PageSize());
        }
        var tabAlreadyOpened = this.ShiftReport.TabViewModel.SearchTabByObjectId('ActiveInfo') != null;
        var infoTab = this.createNewInfoTab();
        if (infoTab) {
            if (tabAlreadyOpened == false) {
                infoTab.IsNew = false;
                infoTab.InfoId = infoId;
                infoTab.ListIndex = index;
            }
            this.loadTab(infoTab, false, infoId, index);
        }
    };
    createNewInfoTab = () => {
        var newTab: any = this.ShiftReport.TabViewModel.SearchTabByObjectId('ActiveInfo');
        if (!newTab) {
            let tabPage: any = this.TabPage;
            newTab = new TabPage('ActiveInfo');
            newTab.AutoSelect = false;
            newTab.Url('Information/Detail');
            newTab.UrlData({
                id: tabPage.FormHistoryId,
                reportId: this.ShiftReport.ReportId(),
                shiftbookId: this.ShiftReport.ShiftbookId()
            });
            newTab.IsClosable(true);
            newTab.PreLoad(true);
            newTab.Visible(true);
            newTab.FormHistoryId = tabPage.FormHistoryId;
            newTab.InformationTab = this;
            newTab.AlreadyLoaded = false;
            this.ShiftReport.TabViewModel.AddTab(newTab);
        }
        return newTab;
    };
    loadTab = (tab, isNew, infoId, listIndex) => {
        this.ShiftReport.TabViewModel.SelectTab(tab);
        if (tab.AlreadyLoaded) {
            var tabViewModel = tab.ViewModel();
            tabViewModel.BeforeClose(function () {
                tab.IsNew = isNew;
                tab.InfoId = infoId;
                tab.ListIndex = listIndex;
                tabViewModel.init().then(tabViewModel.loaded).then(function () {
                    tabViewModel.PagingEnabled(true);
                    if (this && this.ShiftReport)
                        this.ShiftReport.TabViewModel.SelectTab(tabViewModel.TabPage);
                    tabViewModel.toggleButtons();
                    tabViewModel.setTabTitle();
                });
            }, true);
        }
        else {
        }
    };

    dispose() {
        MessageBus.unsubscribe([this.InfoSavedHandler,
        this.InfoDeletedHandler]);
    };

    private registerReportContentChangedHandler = () => {

        MessageBus.subscribe([this.InfoSavedHandler,
        this.InfoDeletedHandler])
            .catch(() => {
                console.warn('Cannot connect to MessageBus');
            });
    }

    protected checkAndNotifyIfRecordChanged = (ids: Array<string>) => {
        //The ids array should almost always contain only one element

        //Do not notify multiple times
        if (this.ReportHasChanges())
            return;

        //Check if the record(s) exist in loaded infos (client side)
        for (var id of ids) {
            for (var inf of this.Infos()) {
                if (String(inf.InfoId).toLowerCase() === id.toLowerCase()) {
                    this.ReportHasChanges(true);
                    return;
                }
            }
        }
        //The record(s) aren't in loaded infos - check if they're relevant to the current report
        this.checkInfoRelevance(ids).then(result => {
            if (result) {
                this.ReportHasChanges(true);
            }
        });
    }
}
export default ShiftReportSummaryReport;